import React, { forwardRef, useEffect, useRef } from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { useAppContext } from '../../providers/AppProvider';

const ReactEchart = forwardRef(({ ...rest }, ref) => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const chartRef = ref ? ref : useRef(null);
	const { isFluid, isNavbarVerticalCollapsed } = useAppContext();

	useEffect(() => {
		const resizeChart = () => {
			try {
				const instance = chartRef.current?.getEchartsInstance?.();
				if (instance && !instance.isDisposed?.()) {
					instance.resize();
					return;
				}
				chartRef.current?.resize?.();
			} catch {
				// 域切换 / 卸载后 window resize 可能找不到 DOM 实例
			}
		};
		resizeChart();
		window.addEventListener('resize', resizeChart);
		return () => window.removeEventListener('resize', resizeChart);
	}, [chartRef, isFluid, isNavbarVerticalCollapsed]);

	return <ReactEChartsCore ref={chartRef} {...rest} />;
});

export default ReactEchart;
